import { useTranslation } from "@coworker/locales";
import { ApplyFilter } from "@coworker/apprestructured/src/shared/filters/types/apply";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { Combined } from "../types/article";
import { AggregatedArticle } from "../hooks/useAggregatedArticles";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";

const GROUPED_ID = "grouped";

function useGroupedArticlesSelectFilter() {
  const { t } = useTranslation();
  const defaultValue = { filterId: GROUPED_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: GROUPED_ID,
      title: t("groupedArticlesString"),
      options: [
        { value: "onlyInGroups", title: t("articlesOnlyInGroupsString") },
        {
          value: "notInGroups",
          title: t("articlesNotInGroupsString"),
        },
      ],
      enabled: true,
      defaultValue,
    },
    t("allArticlesString")
  );
}

function useGroupedArticlesSelectArticleFilter() {
  const filter: ApplyFilter<SelectFilter, AggregatedArticle> = {
    filter: useGroupedArticlesSelectFilter(),
    filterCompare: (
      item: Combined<AggregatedArticle>,
      { value }: FilterValue
    ) => {
      switch (value) {
        case "onlyInGroups":
          if (item.aggregatedArticles.length === item.groupIds.length) {
            return true;
          }
          return false;
        case "notInGroups":
          if (!item.groupIds.length) {
            return true;
          }
          return false;
        default:
          return true;
      }
    },
  };

  return filter;
}

export { useGroupedArticlesSelectArticleFilter };
